<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-3">
        <label>Select Month <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <mat-select class="main-border-class" [(ngModel)]="selected_month">
          <mat-option *ngFor="let month of month_list_for_last_12_months" [value]=month>
            {{month['month_in_string']}} - {{month['year']}}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 22%;border-radius: 5px;background: blanchedalmond;">Get</button>
      </div>
    </div>
    <br>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="document_file!== null">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-4">
          </div>
          <div class="col-4">
            <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
                picture_as_pdf
              </i> Download report</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</section>
